/**
 * This file was automatically generated using "yarn generate:all" command.
 * Please do not edit it manually.
 * 
 * Generate source: local/cli/src/commands/placements/generate-intl-provider.ts
 **/


import { withIntlProvider } from '@post-office/placement-contexts/i18n';
import { messagesLoader as tenantProvisioningLifecycleMessages} from '@post-office/team-package--i18n--tenant-provisioning-lifecycle'
import { messagesLoader as nightswatchMessages} from '@post-office/team-package--i18n--nightswatch'
import { messagesLoader as axPortkeyMessages} from '@post-office/team-package--i18n--ax-portkey'
import { messagesLoader as governanceManagerMessages} from '@post-office/team-package--i18n--governance-manager'
import { messagesLoader as peopleAndTeamsMessages} from '@post-office/team-package--i18n--people-and-teams'
import { messagesLoader as dukeMessages} from '@post-office/team-package--i18n--duke'
import { messagesLoader as rovoConnectorExpansionMessages} from '@post-office/team-package--i18n--rovo-connector-expansion'
import { messagesLoader as brieMessages} from '@post-office/team-package--i18n--brie'
import { messagesLoader as testMessagesMessages} from '@post-office/team-package--i18n--test-messages'
import { messagesLoader as commerceMessages} from '@post-office/team-package--i18n--commerce'
import { messagesLoader as playgroundMessages} from '@post-office/team-package--i18n--playground'
import { messagesLoader as growthTransmutersMessages} from '@post-office/team-package--i18n--growth-transmuters'
import { messagesLoader as enterpriseTrustMessages} from '@post-office/team-package--i18n--enterprise-trust'
import { messagesLoader as integrationsServiceMessages} from '@post-office/team-package--i18n--integrations-service'
import { messagesLoader as postOfficeTemplateMessages} from '@post-office/team-package--i18n--post-office-template'
import { messagesLoader as partnerUnifiedXpMessages} from '@post-office/team-package--i18n--partner-unified-xp'
import { messagesLoader as growthGrootMessages} from '@post-office/team-package--i18n--growth-groot'
import { messagesLoader as studioFoundationsMessages} from '@post-office/team-package--i18n--studio-foundations'
import { messagesLoader as townsquareMessages} from '@post-office/team-package--i18n--townsquare'
import { messagesLoader as scapMessages} from '@post-office/team-package--i18n--scap'
import { messagesLoader as teamworkGraphMessages} from '@post-office/team-package--i18n--teamwork-graph'
import { messagesLoader as uipMessages} from '@post-office/team-package--i18n--uip'
import type { ComponentType } from 'react';

type TranslatedMessages = Record<string, string>;

type TranslatedMessagesResult<T> = { messages: T; errors: Array<string> };

const loadMessagesByTeam = async (locale: string): Promise<TranslatedMessagesResult<TranslatedMessages>> => {
return Promise.allSettled([
tenantProvisioningLifecycleMessages(locale),
nightswatchMessages(locale),
axPortkeyMessages(locale),
governanceManagerMessages(locale),
peopleAndTeamsMessages(locale),
dukeMessages(locale),
rovoConnectorExpansionMessages(locale),
brieMessages(locale),
testMessagesMessages(locale),
commerceMessages(locale),
playgroundMessages(locale),
growthTransmutersMessages(locale),
enterpriseTrustMessages(locale),
integrationsServiceMessages(locale),
postOfficeTemplateMessages(locale),
partnerUnifiedXpMessages(locale),
growthGrootMessages(locale),
studioFoundationsMessages(locale),
townsquareMessages(locale),
scapMessages(locale),
teamworkGraphMessages(locale),
uipMessages(locale),
]).then(results => {
return results.reduce((acc, result) => {
if (result.status === 'fulfilled') {
return {
messages: {
...acc.messages,
...result.value,
} as TranslatedMessages,
errors: [...acc.errors],
}
} else if (result.status === 'rejected') {
return {
messages: { ...acc.messages },
errors: [...acc.errors, `Failed to load translations with ${result.reason}`]
};
}
return acc;
}, { messages: {} as TranslatedMessages, errors: [] as Array<string> });
});
};

export { loadMessagesByTeam as loadPlacementMessages }

/**
 * New IntlProvider for InApp Placements with a restructured messagesLoader, being rolled out soon with Feature Flag
 **/
export const withAdminHubNotificationsIntlProvider = <P extends object>(Component: ComponentType<P>): ComponentType<P &
{ messages?: TranslatedMessages }> => {
	return withIntlProvider<P, TranslatedMessages>(
		{
			messagesLoader: loadMessagesByTeam,
		},
		Component,
	);
};
